// components/groupAdmin/feed/utils/poll.js

const trim = (v) => String(v ?? "").trim();

export function cleanPollOptions(options) {
  return (Array.isArray(options) ? options : [])
    .map((o) => trim(o))
    .filter(Boolean);
}

/**
 * If you pass `t`, validation messages are translated.
 * Otherwise, it falls back to English strings.
 */
export function validatePollInput(question, options, t) {
  const q = trim(question);
  const opts = cleanPollOptions(options);

  const msg = (key, fallback) =>
    typeof t === "function" ? t(key, { defaultValue: fallback }) : fallback;

  if (!q)
    return {
      ok: false,
      message: msg(
        "groupAdminTabs.feed.pollValidation.questionRequired",
        "Poll question is required"
      ),
    };

  if (opts.length < 2)
    return {
      ok: false,
      message: msg(
        "groupAdminTabs.feed.pollValidation.optionsMin",
        "Add at least 2 poll options"
      ),
    };

  if (opts.length > 10)
    return {
      ok: false,
      message: msg(
        "groupAdminTabs.feed.pollValidation.optionsMax",
        "Poll options max is 10"
      ),
    };

  if (q.length > 180)
    return {
      ok: false,
      message: msg(
        "groupAdminTabs.feed.pollValidation.questionTooLong",
        "Poll question is too long"
      ),
    };

  if (opts.some((x) => x.length > 120))
    return {
      ok: false,
      message: msg(
        "groupAdminTabs.feed.pollValidation.optionTooLong",
        "A poll option is too long"
      ),
    };

  return { ok: true };
}

export function buildPollPayload(question, options, { multiple = false } = {}) {
  const q = trim(question);
  const opts = cleanPollOptions(options);

  // Create stable ids for backend usage
  const normalized = opts.map((text, i) => ({ id: `opt_${i + 1}`, text }));
  return { question: q, options: normalized, multiple: !!multiple };
}

export function pollOptionsFromItem(itemPoll) {
  if (!itemPoll) return ["", ""];
  const raw = itemPoll?.options || [];
  const opts = raw
    .map((o) => (typeof o === "string" ? o : o?.text ?? o?.label ?? ""))
    .map((x) => trim(x))
    .filter(Boolean);

  return opts.length >= 2 ? opts : ["", ""];
}
